import * as React from 'react';

import type MaterialCostSource from 'ab-enums/materialCostSource.enum';

import Checkbox from 'af-components/Controls/Checkbox';
import MaterialRateSource from 'af-components/MaterialRateSource';

import { useMaterialCostSourceFilterContext } from '../../../MaterialCostSourceFilterContext';

interface OwnProps {
	source: MaterialCostSource;
}

type Props = OwnProps;

const CostSourceFilter: React.FC<Props> = (props) => {
	const { source } = props;

	const { toggle, filters } = useMaterialCostSourceFilterContext();

	const handleCheck = React.useCallback(() => {
		toggle(source);
	}, [source, toggle]);

	return (
		<Checkbox
			handleChange={handleCheck}
			isChecked={filters[source]}
			label={<MaterialRateSource rateSource={source} />}
		/>
	);
};

export default React.memo(CostSourceFilter);
